import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative pt-4 px-4 flex-grow" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center gap-2"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " Loading integration... ", -1)
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col gap-3"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"flex gap-2 items-center\"><div class=\"h-8\"><svg height=\"100%\" width=\"100%\" viewBox=\"0 0 127 127\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m27.2 80c0 7.3-5.9 13.2-13.2 13.2s-13.2-5.9-13.2-13.2 5.9-13.2 13.2-13.2h13.2zm6.6 0c0-7.3 5.9-13.2 13.2-13.2s13.2 5.9 13.2 13.2v33c0 7.3-5.9 13.2-13.2 13.2s-13.2-5.9-13.2-13.2z\" fill=\"#e01e5a\"></path><path d=\"m47 27c-7.3 0-13.2-5.9-13.2-13.2s5.9-13.2 13.2-13.2 13.2 5.9 13.2 13.2v13.2zm0 6.7c7.3 0 13.2 5.9 13.2 13.2s-5.9 13.2-13.2 13.2h-33.1c-7.3 0-13.2-5.9-13.2-13.2s5.9-13.2 13.2-13.2z\" fill=\"#36c5f0\"></path><path d=\"m99.9 46.9c0-7.3 5.9-13.2 13.2-13.2s13.2 5.9 13.2 13.2-5.9 13.2-13.2 13.2h-13.2zm-6.6 0c0 7.3-5.9 13.2-13.2 13.2s-13.2-5.9-13.2-13.2v-33.1c0-7.3 5.9-13.2 13.2-13.2s13.2 5.9 13.2 13.2z\" fill=\"#2eb67d\"></path><path d=\"m80.1 99.8c7.3 0 13.2 5.9 13.2 13.2s-5.9 13.2-13.2 13.2-13.2-5.9-13.2-13.2v-13.2zm0-6.6c-7.3 0-13.2-5.9-13.2-13.2s5.9-13.2 13.2-13.2h33.1c7.3 0 13.2 5.9 13.2 13.2s-5.9 13.2-13.2 13.2z\" fill=\"#ecb22e\"></path></svg></div><h1 class=\"text-3xl font-bold\">Slack</h1></div><p>Integrate Thatch into Slack</p>", 2)
const _hoisted_7 = { class: "flex flex-col gap-6" }
const _hoisted_8 = { class: "flex items-center gap-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, " Inbound file notifications ", -1)
const _hoisted_10 = {
  key: 0,
  class: "bg-green-500 text-xs text-white rounded-md py-0.5 px-4"
}
const _hoisted_11 = {
  key: 1,
  class: "bg-red-400 text-white rounded-md py-0.5 text-xs px-4"
}
const _hoisted_12 = { class: "flex items-center justify-between gap-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, " Keep your team updated with the latest messages you receive in Thatch. Post all of your incoming mail, incoming faxes, SMS, and voicemails directly to a specific Slack channel you choose ", -1)
const _hoisted_14 = { class: "mt-4 flex flex-col gap-3" }
const _hoisted_15 = { class: "flex items-center justify-between" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Inbound physical mail notifications", -1)
const _hoisted_17 = { class: "flex items-center justify-between" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Inbound email notifications", -1)
const _hoisted_19 = { class: "flex items-center justify-between" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Inbound fax notifications", -1)
const _hoisted_21 = { class: "flex items-center justify-between" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "Voicemail notifications", -1)
const _hoisted_23 = { class: "flex items-center justify-between" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "SMS notifications", -1)

import { UiLoader, UiCard, UiButton } from '@/ui-kit';
import { Switch } from '@headlessui/vue';
import { useToggle } from '@vueuse/core';
import { useIntegrations } from '../use-intergations';
import { onBeforeMount } from 'vue';
import { env } from '@/config';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'Slack',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const {
	slackIntegration,
	isLoaded,
	loadSlack,
	attachSlack,
	switchSlackSetting,
	deleteSlackSetting
} = useIntegrations();
const [isConnecting, setIsConnecting] = useToggle();

const slackLink = `${env.SLACK_LINK}&state=${
	Math.random().toString(36).substring(2, 15) +
	Math.random().toString(36).substring(2, 15) +
	Math.random().toString(36).substring(2, 15) +
	Math.random().toString(36).substring(2, 15)
}`;

onBeforeMount(() => {
	if (route.query.code) {
		setIsConnecting(true);
		attachSlack(
			route.query.code as string,
			`${window.location.origin}${window.location.pathname}`
		);
		router.replace({ name: 'SlackIntegration' });
		setIsConnecting(false);
		return;
	}
	if (route.query.error) {
		router.replace({ name: 'SlackIntegration' });
	}
	if (!isLoaded.value) {
		loadSlack();
	}
});

function getIntegrationSettingByKey(key: string) {
	if (!slackIntegration.value) {
		return false;
	}
	return !!slackIntegration.value.settings.find(
		(setting) => setting.type === key
	)?.is_enabled;
}

function getIntegrationSettingIdByKey(key: string) {
	if (!slackIntegration.value) {
		return;
	}
	return slackIntegration.value.settings.find(
		(setting) => setting.type === key
	)?.id;
}

function toggle(key: string) {
	const id = getIntegrationSettingIdByKey(key);

	if (!id) {
		return;
	}

	switchSlackSetting(id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isLoaded) || _unref(isConnecting))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_unref(UiLoader))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_unref(UiCard), { theme: "white" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  (_unref(slackIntegration))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Enabled "))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, " Disabled "))
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  (!_unref(slackIntegration))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: slackLink
                      }, [
                        _createVNode(_unref(UiButton), {
                          class: "!h-8",
                          theme: "primary-outlined"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Connect ")
                          ]),
                          _: 1
                        })
                      ]))
                    : (_openBlock(), _createBlock(_unref(UiButton), {
                        key: 1,
                        onClick: _unref(deleteSlackSetting),
                        class: "!h-8",
                        theme: "danger-outlined"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Disconnect ")
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createVNode(_unref(Switch), {
                      modelValue: 
									getIntegrationSettingByKey(
										'physical-mail'
									)
								,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (
									toggle('physical-mail')
								)),
                      class: _normalizeClass([[
									getIntegrationSettingByKey(
										'physical-mail'
									)
										? 'bg-blue-600'
										: 'bg-gray-300',
									{
										'opacity-50 cursor-default':
											!_unref(slackIntegration)
									}
								], "relative cursor-pointer inline-flex h-6 w-11 items-center rounded-full"]),
                      disabled: 
									!_unref(slackIntegration)
								
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass([[
										getIntegrationSettingByKey(
											'physical-mail'
										)
											? 'translate-x-6'
											: 'translate-x-1',
										{
											'opacity-50':
												!_unref(slackIntegration)
										}
									], "inline-block h-4 w-4 transform rounded-full bg-white transition"])
                        }, null, 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_unref(Switch), {
                      modelValue: 
									getIntegrationSettingByKey(
										'email'
									)
								,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (
									toggle('email')
								)),
                      class: _normalizeClass([[
									getIntegrationSettingByKey(
										'email'
									)
										? 'bg-blue-600'
										: 'bg-gray-300',
									{
										'opacity-50 cursor-default':
											!_unref(slackIntegration)
									}
								], "relative cursor-pointer inline-flex h-6 w-11 items-center rounded-full"]),
                      disabled: 
									!_unref(slackIntegration)
								
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass([[
										getIntegrationSettingByKey(
											'email'
										)
											? 'translate-x-6'
											: 'translate-x-1',
										{
											'opacity-50':
												!_unref(slackIntegration)
										}
									], "inline-block h-4 w-4 transform rounded-full bg-white transition"])
                        }, null, 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "class", "disabled"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createVNode(_unref(Switch), {
                      modelValue: 
									getIntegrationSettingByKey(
										'fax'
									)
								,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (
									toggle('fax')
								)),
                      disabled: 
									!_unref(slackIntegration)
								,
                      class: _normalizeClass([[
									getIntegrationSettingByKey(
										'fax'
									)
										? 'bg-blue-600'
										: 'bg-gray-300',
									{
										'opacity-50 cursor-default':
											!_unref(slackIntegration)
									}
								], "relative inline-flex cursor-pointer h-6 w-11 items-center rounded-full"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass([[
										getIntegrationSettingByKey(
											'fax'
										)
											? 'translate-x-6'
											: 'translate-x-1',
										{
											'opacity-50':
												!_unref(slackIntegration)
										}
									], "inline-block h-4 w-4 transform rounded-full bg-white transition"])
                        }, null, 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled", "class"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_unref(Switch), {
                      modelValue: 
									getIntegrationSettingByKey(
										'voicemail'
									)
								,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (
									toggle('voicemail')
								)),
                      disabled: 
									!_unref(slackIntegration)
								,
                      class: _normalizeClass([[
									getIntegrationSettingByKey(
										'voicemail'
									)
										? 'bg-blue-600'
										: 'bg-gray-300',
									{
										'opacity-50 cursor-default':
											!_unref(slackIntegration)
									}
								], "relative inline-flex cursor-pointer h-6 w-11 items-center rounded-full"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass([[
										getIntegrationSettingByKey(
											'voicemail'
										)
											? 'translate-x-6'
											: 'translate-x-1',
										{
											'opacity-50':
												!_unref(slackIntegration)
										}
									], "inline-block h-4 w-4 transform rounded-full bg-white transition"])
                        }, null, 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled", "class"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createVNode(_unref(Switch), {
                      modelValue: 
									getIntegrationSettingByKey(
										'sms'
									)
								,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (
									toggle('sms')
								)),
                      disabled: 
									!_unref(slackIntegration)
								,
                      class: _normalizeClass([[
									getIntegrationSettingByKey(
										'sms'
									)
										? 'bg-blue-600'
										: 'bg-gray-300',
									{
										'opacity-50 cursor-default':
											!_unref(slackIntegration)
									}
								], "relative inline-flex h-6 w-11 cursor-pointer items-center rounded-full"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: _normalizeClass([[
										getIntegrationSettingByKey(
											'sms'
										)
											? 'translate-x-6'
											: 'translate-x-1',
										{
											'opacity-50':
												!_unref(slackIntegration)
										}
									], "inline-block h-4 w-4 transform rounded-full bg-white transition"])
                        }, null, 2)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled", "class"])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})